import { invokeBackendRoute } from '@/backend/invoke';

import type { GenerateGoogleAuthUrl } from '@cloudFunctions/types/googleWorkspace/generateGoogleAuthUrl';
import type { GetGoogleCredentials } from '@cloudFunctions/types/googleWorkspace/getGoogleCredentials';
import type { RevokeGoogleCredentials } from '@cloudFunctions/types/googleWorkspace/revokeGoogleCredentials';
import type { SendGoogleEmail } from '@cloudFunctions/types/googleWorkspace/sendGoogleEmail';
export type {
  GenerateGoogleAuthUrl,
  GetGoogleCredentials,
  RevokeGoogleCredentials,
  SendGoogleEmail,
};

export type GoogleCredentials =
  GetGoogleCredentials.SuccessPayload['credentials'];

/**
 * Generates a Google OAuth 2.0 authorization URL.
 */
export const generateGoogleAuthUrl =
  async (): Promise<GenerateGoogleAuthUrl.Result> =>
    invokeBackendRoute<GenerateGoogleAuthUrl.Result>('generateGoogleAuthUrl');

/**
 * Retrieves the current Google credentials for the user.
 */
export const getGoogleCredentials =
  async (): Promise<GetGoogleCredentials.Result> =>
    invokeBackendRoute<GetGoogleCredentials.Result>('getGoogleCredentials');

/**
 * Sends an email using the authenticated user's Google account.
 */
export const sendGoogleEmail = async (
  requestData: SendGoogleEmail.RequestData,
): Promise<SendGoogleEmail.Result> =>
  invokeBackendRoute<SendGoogleEmail.Result, SendGoogleEmail.RequestData>(
    'sendGoogleEmail',
    requestData,
  );

/**
 * Revokes the user's Google credentials, effectively logging them out of Google services within the app.
 */
export const revokeGoogleCredentials =
  async (): Promise<RevokeGoogleCredentials.Result> =>
    invokeBackendRoute<RevokeGoogleCredentials.Result>(
      'revokeGoogleCredentials',
    );
